// umlaut-check: skip — "zuruecksetzen" ist der technische Name aus
// useGemerkteFilter.jsx, bleibt ASCII.
import React, {useState} from 'react';
import InertiaTable from 'laravel-inertia-react-table';
import {usePage} from '@inertiajs/react';
import ImportPositionsModal from './ImportPositionsModal.jsx';
import {Button, useEnhancedTranslation} from "laravel-inertia-backend";
import {PiMicrosoftExcelLogo, PiPencil, PiTrash} from "react-icons/pi";
import {WeclappIcon} from "../../Icons/WeclappIcon.js";
import CurrencyTableCell from "../../Components/CurrencyTableCell.jsx";
import TimestampTableCell from "../../Components/TimestampTableCell.jsx";
import HelpTooltip from "../../Components/HelpTooltip.jsx";
import {AlleFilterZuruecksetzenLink, useGemerkteServerFilter} from "../../Components/Filter/useGemerkteFilter.jsx";

export default function CreditMemos() {
    const {weclappBaseUrl, user_roles,credit_memos, col_definitions, auth} = usePage().props;
    const [showModal, setShowModal] = useState(false);
    const [selectedDocumentId, setSelectedDocumentId] = useState(null);
    const {t} = useEnhancedTranslation();
    const {weichtAb, zuruecksetzen} = useGemerkteServerFilter("weclapp.credit-memos", {benutzerId: auth?.id});

    const openImportFor = (id) => {
        setSelectedDocumentId(id);
        setShowModal(true);
    }

    const openWeclappOrder = (id) => {
        window.open(`${weclappBaseUrl}app/sales-invoice/${id}`, '_blank');
    }

    return (<>
            <InertiaTable
                key={'credit-memos-table'}
                data={credit_memos}
                title={
                  <span className="d-inline-flex align-items-center gap-2">
                    Verkauf – Gutschriften
                    <HelpTooltip placement="right" size={0.95}>
                      <div className="text-start">
                        <strong>Welche Belege werden hier angezeigt?</strong>
                        <div className="mt-1">Gutschriften aus Weclapp nach festen Regeln:</div>
                        <ul className="mb-0 ps-3 mt-1">
                          <li>Belegtyp: <strong>Verkaufsrechnung</strong>, Typ <strong>CREDIT_NOTE</strong> (Gutschrift)</li>
                          <li>Status: <strong>NEW</strong> – neu erfasst, noch nicht abgeschlossen</li>
                        </ul>
                        <div className="mt-1">Sortierung: Nummer absteigend.</div>
                      </div>
                    </HelpTooltip>
                  </span>
                }
                actionsDisplay={'column'}
                actions={[
                    { icon: <PiMicrosoftExcelLogo />, alt: t('import from File'), callback: (data) =>openImportFor(data.id) },
                    { icon: <WeclappIcon />, alt:  t('open in Weclapp'), callback: (data) =>openWeclappOrder(data.id) },

                ]}
                colDefinitions={[...col_definitions]}
                customCellRendererMap={{
                    'netAmount': CurrencyTableCell,
                    'invoiceDate':TimestampTableCell
            }}
                customToolbarButtons={<AlleFilterZuruecksetzenLink sichtbar={weichtAb} onClick={zuruecksetzen} />}
            />
            <ImportPositionsModal show={showModal} documentId={selectedDocumentId} documentType={'credit_memo'} onClose={() => setShowModal(false)}/>
        </>
    );
}
